module.exports = __webpack_public_path__ + "ee47691a3fbffe8d5944b8552f64bc80.svg";